/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useState } from "react";
import {
  NavItem,
  NavLink,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { RoutesEnum } from "../../utils/RoutesUtil";
import { TrackersEnum } from "../../models/TrackerModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComment, faUsersGear } from "@fortawesome/free-solid-svg-icons";
import "./navigation.scss";
import { BankUserContext } from "../../bankUserContext";
import { IOrgProductModel } from "../../models/SharedModel";
import RoleAuthorization from "../Authentication/RoleAuthorization";
import { Pages, actionAuthorization } from "../../utils/RolesUtil";
import ClientSideBar from "./SideNav/ClientSidebar";

interface SideBarProps {
  LogoData: any;
  productRedirection: (value: IOrgProductModel, trackerType?: TrackersEnum | string) => void;
  showProductsHeader: boolean;
  MenuItemsData: any;
}

const SideBar: React.FC<SideBarProps> = ({
  LogoData, MenuItemsData,
  productRedirection,
}) => {
  const { orgProductsList, selectedProduct } = useContext(BankUserContext);
  // const [logosList, setLogosList] = useState<IOrgProductModel[]>([]);
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(''); 

  const handleNavLinkClick = (linkName: React.SetStateAction<string>) => {
    setActiveLink(linkName);

  };
  const currentUrl = location.pathname;
  const rolesAuthorization = (action: string) => {
    return RoleAuthorization(location.pathname, action)
  }
  // if (location.pathname.indexOf("complianceView") > -1) {
  //   setShowCompliances(true);
  // }


  return (
    <React.Fragment>
      {/* {showCompliances && <ClientSideBar />} */}
      <div className="sidebar">
        <Nav vertical>
 
          {rolesAuthorization(actionAuthorization.prospectingMenuItem) && <NavItem
            className={activeLink === 'prospecting' || currentUrl?.includes("prospecting") ? 'active' : ''}
            onClick={() => handleNavLinkClick('prospecting')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.TRACKER}/${TrackersEnum.PROSPECTING}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "prospectingIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "prospectingActiveIcon"
                  )?.logopath
                }
              />
              {/* {TrackersEnum.PROSPECTING} */}
              <span>{MenuItemsData.prospecting ? MenuItemsData.prospecting : TrackersEnum.PROSPECTING}</span>
            </NavLink>
          </NavItem>}

          {rolesAuthorization(actionAuthorization.applicationTrackerMenuItem) && <UncontrolledDropdown nav inNavbar
            className={activeLink === 'applications' || currentUrl?.includes("applications") ? 'active' : ''}
            onClick={() => handleNavLinkClick('applications')}>
            <DropdownToggle nav>
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "applicationsIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "applicationsActiveIcon"
                  )?.logopath
                }
              />
              {/* {TrackersEnum.APPLICATIONS} */}
              <span>{MenuItemsData.applications ? MenuItemsData.applications : TrackersEnum.APPLICATIONS}</span>
            </DropdownToggle>
            <DropdownMenu>
              {orgProductsList && orgProductsList?.length > 0 ? (
                orgProductsList?.map((each: IOrgProductModel) => (
                  <DropdownItem toggle={false}
                    key={each?.orgLevelProductId}
                    onClick={() => productRedirection(each, TrackersEnum.APPLICATIONS)}
                  >
                    {each?.productName}
                  </DropdownItem>
                ))
              ) : (
                <></>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>}

          {rolesAuthorization(actionAuthorization.oppurtuntiesMenuItem) && <UncontrolledDropdown nav inNavbar
            className={activeLink === 'opportunities' || currentUrl?.includes("opportunities") ? 'active' : ''}
            onClick={() => handleNavLinkClick('opportunities')}>
            <DropdownToggle nav>
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "opportunitiesIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "opportunitiesActiveIcon"
                  )?.logopath
                }
              />
              {/* {TrackersEnum.OPPORTUNITIES} */}
              <span>{MenuItemsData.opportunities ? MenuItemsData.opportunities : TrackersEnum.OPPORTUNITIES}</span>
            </DropdownToggle>
            <DropdownMenu>
              {orgProductsList && orgProductsList?.length > 0 ? (
                orgProductsList?.map((each: IOrgProductModel) => (
                  <DropdownItem toggle={false}
                    key={each?.orgLevelProductId}
                    onClick={() => productRedirection(each, TrackersEnum.OPPORTUNITIES)}
                  >
                    {each?.productName}
                  </DropdownItem>
                ))
              ) : (
                <></>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>}

          {rolesAuthorization(actionAuthorization.underwritingMenuItem) &&
            <UncontrolledDropdown nav inNavbar
              className={activeLink === 'underwriting' || currentUrl?.includes("underwriting") ? 'active' : ''}
              onClick={() => handleNavLinkClick('underwriting')}>
              <DropdownToggle nav>
                <img className="defaultIcon"
                  src={
                    LogoData?.find(
                      (item: any) => item.iconkey === "underwritingIcon"
                    )?.logopath
                  }
                />
                <img className="activeIcon"
                  src={
                    LogoData?.find(
                      (item: any) => item.iconkey === "underwritingActiveIcon"
                    )?.logopath
                  }
                />
                <span>{MenuItemsData.underwriting ? MenuItemsData.underwriting : TrackersEnum.UNDERWRITING}</span>
              </DropdownToggle>
              <DropdownMenu>
                {orgProductsList && orgProductsList?.length > 0 ? (
                  orgProductsList?.map((each: IOrgProductModel) => (
                    <DropdownItem toggle={false}
                      key={each?.orgLevelProductId}
                      onClick={() => productRedirection(each, TrackersEnum.UNDERWRITING)}
                    >
                      {each?.productName}
                    </DropdownItem>
                  ))
                ) : (
                  <></>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>}

          {rolesAuthorization(actionAuthorization.relationshipsMenuItem) && <NavItem
            className={activeLink === 'relationships' || currentUrl?.includes("relationships") ? 'active' : ''}
            onClick={() => handleNavLinkClick('relationships')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.TRACKER}/${TrackersEnum.RELATIONSHIPS}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "relationshipIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "relationshipActiveIcon"
                  )?.logopath
                }
              />
              {/* {TrackersEnum.RELATIONSHIPS} */}
              <span>{MenuItemsData.relationship ? MenuItemsData.relationship : TrackersEnum.RELATIONSHIPS}</span>
            </NavLink>
          </NavItem>}
          {rolesAuthorization(actionAuthorization.dashboardMenuItems) && <NavItem
            className={activeLink === 'dashboard' || currentUrl?.includes("dashboard") ? 'active' : ''}
            onClick={() => handleNavLinkClick('dashboard')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.DASHBOARD}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "dashboardIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "dashboardActiveIcon"
                  )?.logopath
                }
              />            
              <span>{MenuItemsData.dashboard ? MenuItemsData.dashboard : TrackersEnum.DASHBOARD}</span>
            </NavLink>
          </NavItem>
          }

          {rolesAuthorization(actionAuthorization.caseMangementMenuItems) && <NavItem
            className={activeLink === 'caseTracker' || currentUrl?.includes("caseTracker") ? 'active' : ''}
            onClick={() => handleNavLinkClick('caseTracker')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.CASETRACKER}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "caseTrackerIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "caseTrackerIconActiveIcon"
                  )?.logopath
                }
              />
              {/* {TrackersEnum.CASETRACKER} */}
              <span>{MenuItemsData.caseTracker ? MenuItemsData.caseTracker : TrackersEnum.CASETRACKER}</span>
            </NavLink>
          </NavItem>}


          {rolesAuthorization(actionAuthorization.messagesMenuItems) && <NavItem
            className={activeLink === 'messagecenter' || currentUrl?.includes("messagecenter") ? 'active' : ''}
            onClick={() => handleNavLinkClick('messagecenter')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.MESSAGE_CENTER}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "messageCenterIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "messageCenterActiveIcon"
                  )?.logopath
                }
              />
              {/* Message Center */}
              <span>{MenuItemsData.messageCenter ? MenuItemsData.messageCenter : TrackersEnum.MESSAGECENTER}</span>
            </NavLink>
          </NavItem>}

          {rolesAuthorization(actionAuthorization.settingMenuItems) && <NavItem
            className={activeLink === 'settings' ? 'active' : ''}
            onClick={() => handleNavLinkClick('settings')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.SETTINGS}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "settingsIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "settingsIconActiveIcon"
                  )?.logopath
                }
              />
              {/* {TrackersEnum.SETTINGS} */}
              <span>{MenuItemsData.settings ? MenuItemsData.settings : TrackersEnum.SETTINGS}</span>
            </NavLink>
          </NavItem>}

       
       

          {/* {rolesAuthorization(actionAuthorization.adminSettingsMenuItems) && 
          <NavItem
            className={activeLink === 'adminsettings' ? 'active' : ''}
            onClick={() => handleNavLinkClick('adminsettings')}>
            <NavLink
              tag={Link}
              to={`${RoutesEnum.ADMINSETTINGS}`}
            >
              <img className="defaultIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === "adminSettingsIcon"
                  )?.logopath
                }
              />
              <img className="activeIcon"
                src={
                  LogoData?.find(
                    (item: any) => item.iconkey === ""
                  )?.logopath
                }
              />
              <span>{MenuItemsData.adminsettings ? MenuItemsData.adminsettings : TrackersEnum.ADMINSETTINGS}</span>
            </NavLink>
          </NavItem>
          } */}
          {/* Add more menu items as needed */}
        </Nav>
      </div>
    </React.Fragment>
  );
};

export default SideBar;
